exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".app_link{display:none !important}#peek ul{margin-bottom:0}.layout-477209d1{height:100vh;max-height:100vh;overflow:hidden;position:relative;display:flex;flex-direction:column}.RouteShowPage-0f6733c9{flex:1 1 100%;min-height:0;position:relative}.layout-477209d1.collapse-8a5b90b8{height:auto;display:block;max-height:none}\n", ""]);

// Exports
exports.locals = {
	"layout": "layout-477209d1",
	"RouteShowPage": "RouteShowPage-0f6733c9",
	"collapse": "collapse-8a5b90b8"
};